export default "__VITE_ASSET__DWBtBWm1__"